"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSuccessNotification = void 0;
const Notification_1 = require("./Notification");
function useSuccessNotification(props) {
    const { notification: successNotification, setNotification: setSuccessNotification, } = Notification_1.useNotification(props);
    return { successNotification, setSuccessNotification };
}
exports.useSuccessNotification = useSuccessNotification;
//# sourceMappingURL=SuccessNotification.js.map